import React from "react";
import Window from "./Window";
import "./FreeBets.css";

export default class FreeBets extends React.Component<FreeBets.Props, FreeBets.State>
{


    constructor(props: FreeBets.Props)
    {
        super(props);
        this.state = {
            content: "none"
        }
    }


    render()
    {
        const data = window.lang.shared.modals["free-bets-management"];
        const renderData: any = this.state.content == "none"
            ? this.renderActiveFreeBets()
            : this.renderArchive();

        return (
            <Window
                id="freeBets"
                title={data["title"]}
            >
                {renderData}
            </Window>
        )
    }


    clickArchive()
    {
        this.setState({ content: "archive" });
    }

    clickActiveBets()
    {
        this.setState({ content: "none" });
    }

    renderActiveFreeBets()
    {
        const arr = [] as Array<JSX.Element>;
        const lang = window.lang.shared.modals["free-bets-management"];
        const lShared = window.lang.shared;

        arr.push(
            <>
                <div className="playWithCash">
                    <div className="greenCircle"></div>
                    <div className="title">
                        {lang["play with cash"]}
                    </div>
                </div>


                <div className="head" style={{paddingLeft: "5px"}}>
                    <div className="titleOne">{lang["active free bets"]}</div>
                    <div className="archive-btn" onClick={this.clickArchive.bind(this)}>
                        <div className="icon"></div>
                        {lShared["archive"]}
                    </div>
                </div>

                <div className="content">
                    <img className="free-bets-icon" src={"gfx/free_bets/ticket.svg?version=" + version} />
                    <div style={{ marginTop: "12px" }}>
                        {lang["no active free bets"]}
                    </div>
                </div>
            </>
        );

        return arr;
    }


    renderArchive()
    {
        const arr = [] as Array<JSX.Element>;
        const lang = window.lang.shared.modals["free-bets-management"];
        const lShared = window.lang.shared;

        arr.push(
            <>

                <div className="head">
                    <div className="titleOne">{lShared.archive}</div>
                    <div className="archive-btn" onClick={this.clickActiveBets.bind(this)}>
                        <div className="icon-x"></div>
                        {lShared["back"]}
                    </div>
                </div>

                <div className="content">
                    <img className="free-bets-icon" src={"gfx/free_bets/ticket.svg?version=" + version} />
                    <div style={{ marginTop: "12px" }}>
                        {lang["nothing yet"]}
                    </div>
                </div>
            </>
        );

        return arr;
    }


}


export namespace FreeBets
{


    export interface Props
    {

    }


    export interface State
    {
        content: "none" | "archive";
    }


}